module.exports = __webpack_public_path__ + "static/media/hsin_yen_chen.9295bd74.jpg";